import { ICollectionTag } from '@monofront/types';
import CarouselTags from '@components/CarouselTags';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { trackEvent } from '@monofront/tracking';
import { useTranslations } from 'next-intl';
import { useMediaQuery } from '@monofront/business/hooks';

interface IHeroCollectionProps {
  childCollections: ICollectionTag[];
  searchTerm: string;
}

const HeroCollection: React.FC<IHeroCollectionProps> = ({
  childCollections,
  searchTerm,
}) => {
  const tCatalog = useTranslations('Catalog');
  const isMobileClient = useMediaQuery(800);

  const titleTradKey = isMobileClient ? 'refineFor' : 'refineSearchFor';
  const title = tCatalog(titleTradKey, { query: searchTerm });

  const onCollectionClick = (collection: ICollectionTag) => {
    trackEvent({
      type: 'LFSearchToCollectionClick',
      data: {
        searchTerm: searchTerm,
        collectionName: collection.title,
        collectionSlug: `/collections/${collection.handle}`,
      },
    });
  };

  return (
    <>
      <div className="hero-collection-container">
        <div className="container-img">
          <ResponsiveImage
            src="/images/search-header.svg"
            width={104}
            height={140}
            layout="fill"
            objectFit="contain"
            priority
          />
        </div>
        <div className="container-title-and-carousel">
          <h1>{title}</h1>
          <CarouselTags
            tagList={childCollections}
            hyperlinkVariant="button-secondary"
            onClick={onCollectionClick}
          />
        </div>
      </div>
      <style jsx>{`
        .hero-collection-container {
          display: flex;
          border-radius: var(--rd-3);
          background-color: var(--clr-primary-5);
          height: 140px;
          padding: var(--space-4) var(--space-5);
        }

        .container-img {
          position: relative;
          width: 104px;
          min-width: 104px;
          height: 140px;
          margin-right: var(--space-7);
          top: -8px;
        }

        .container-title-and-carousel {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
        }

        .container-title-and-carousel :global(.swiper-slide) {
          /* setting it on CarouselSlide style props does not work https://github.com/nolimits4web/swiper/pull/6475 */
          margin-right: var(--space-2) !important;
        }

        .container-title-and-carousel > h1 {
          font-size: var(--font-size-3);
          margin-bottom: var(--space-1);
        }

        @media (max-width: 800px) {
          .hero-collection-container {
            border-radius: inherit;
            height: 99px;
            padding: 0;
            overflow: hidden;
          }

          .container-img {
            display: none;
          }

          .container-title-and-carousel h1 {
            font-size: var(--font-size-2-5);
            margin-bottom: var(--space-2);
            padding-left: var(--space-4);
          }
        }
      `}</style>
    </>
  );
};

export default HeroCollection;
